// extracted by mini-css-extract-plugin
export default {"container":"HCoEMoG4uf4R3xhqN_id","tooltip":"a2SFejUawo_vnmfSlpXA"};